export default "__VITE_ASSET__D9MNYySP__"